export const features = {
    "template": "template1",
    "companyName": "Dryden Mutual Insurance Co. (MODEL4)",
    "inowEndpoint": "https://model4.drydenmutual.com",
    "tokenIssuer": "https://dmic-inow.oktapreview.com/oauth2/default",
    "clientId": "0oai03dch5L7JAwny1d7",
    "features": {
        "CustomContentPage1": false,
        "CustomContentPage2": false,
        "addRegistrationEmail": false,
        "affiliatedCarrierAccess": false,
        "agentEmail": false,
        "agentLink": false,
        "agentPanel": true,
        "blockAchNumberOps": true,
        "cancelFutureScheduledPayments": false,
        "changeCoverage": true,
        "claimDetailsDocuments": true,
        "claimDetailsPayments": true,
        "claimDocumentUpload": false,
        "claimList": false,
        "claimStatus": true,
        "combinePolicies": true,
        "coverageDetails": false,
        "cpPortalLinking": false,
        "customPrivacyStatement": false,
        "customTOS": false,
        "customerInformation": true,
        "deactivateUserOnly": false,
        "defaultLossDateTime": false,
        "desktopDeliveryPreferencesDefaultExpanded": true,
        "editPayPlan": false,
        "hasOpenBalance": true,
        "loginPanelExpirationDate": "2080-01-01",
        "mfaEnabled": true,
        "mobileDeliveryPreferencesDefaultExpanded": false,
        "needHelp": true,
        "notificationPreferences": false,
        "otherPaymentAmountAllowed": true,
        "paperlessChoiceUpdate": true,
        "passwordResetInfo": false,
        "payPlanTypesToFilter": [
            "Mortgagee",
            "Agent",
            "Statement"
        ],
        "pendingOrScheduledPaymentsList": true,
        "policyDetailsAddress": true,
        "policyDetailsAddressTypeCd": [
            "InsuredMailingAddr",
            "InsuredBillingAddr"
        ],
        "policyDocumentUpload": true,
        "policyForms": false,
        "policyFormsDownload": false,
        "policyUserAttachmentsDisplay": false,
        "printButtonEnabled": true,
        "recentPaymentsList": true,
        "rememberMe": true,
        "reportClaim": false,
        "scheduledPayments": false,
        "showImageTag": true,
        "showInstallPWA": false,
        "showPasswordToggle": true,
        "standardPhoneLength": false,
        "unauthenticatedPayments": true,
        "unauthenticatedReportClaim": false,
        "underlyingPoliciesPayPlansEditable": false,
        "useGooglePlacesInReportClaimFlow": true,
        "verifyAddress": true,
        "verifyFlow": true,
        "viewChangeRequests": false
    },
    "keys": {
        "googleAnalytics": "",
        "googleAnalytics4": null,
        "googleAnalytics4GwDev": "G-R8Y22B4GYL",
        "googleAnalytics4GwProd": "G-C0D8F7WEDX",
        "googlePlacesApi": "AIzaSyC2GI0oyjPKJztd1DRCgGBWpxKAn332YoQ"
    },
    "salesPortalUrl": "https://dmic-model4-cp.nu-1-us-west-2.guidewire.net",
    "cpProducts": [
        "Homeowners",
        "Personal Auto"
    ],
    "paymentApiUrl": "https://midas.api.omega2-andromeda.guidewire.net",
    "paymentSdkUrl": "https://js-sdk-prod.payments.guidewire.net/v1/gw-payments-sdk.js",
    "paymentTenantName": "tenant.dmic",
    "paymentConfigIds": {
        "DMIC": "12860502"
    },
    "paymentMethods": [
        "ACH",
        "CC"
    ],
    "anonymousPaymentMethods": [
        "ACH",
        "CC"
    ],
    "achEntryClassCode": "PPD",
    "processingFee": 4.95,
    "maxUploadFileSize": "500mb",
    "attachmentTemplatesLimit": "60",
    "policiesCountLimit": "60",
    "billingAccountsCountLimit": "60",
    "faviconFileExtension": "ico",
    "policyCreatedSinceDt": 365,
    "policyStatusCd": "Active,Non-Renewed,Non-Renew Requested,Cancel Notice",
    "passwordConstraints": [
        {
            "constraint": "minLength",
            "value": 12,
            "message": "Use at least 12 characters"
        },
        {
            "constraint": "minNumber",
            "value": 1,
            "message": "Contain at least one number"
        },
        {
            "constraint": "minLowerCase",
            "value": 1,
            "message": "Contain at least one lower case letter"
        },
        {
            "constraint": "minUpperCase",
            "value": 1,
            "message": "Contain at least one upper case letter"
        }
    ],
    "userIdConstraints": [
        {
            "constraint": "minLength",
            "value": 3,
            "message": "Use at least 3 characters"
        }
    ],
    "downTime": {
        "beginTime": "2024-07-21T17:00-05:00",
        "endTime": "2024-07-21T17:00-05:00",
        "title": "<p>System Down for Maintenance</p>",
        "body": "<p>The Customer Portal will be unavailable due to system maintenance from Friday, 7/19/24 @ 4:30pm EST through Sunday, 7/21/24 @9am EST. We apologize for any inconvenience that this may cause.</p>"
    },
    "signIn": {
        "title": "<p>Welcome to the Dryden Mutual Customer Portal</p>",
        "body": "<p><ul><li><b>Seamless One-Time Payments:</b> Effortlessly manage or update your saved payment details.</li><li><b>Mail Your Way:</b> Update your email and delivery preferences.</li><li><b>Digital Documents:</b> Download or print your current policy documents anytime.</li><li><b>Enhanced Security:</b> Mandatory MFA keeps your account secure.</li><li><b>Browsers:</b> Chrome, Edge, or Safari.</li></ul></p><br/><h4 style='color:#c42a34;'>Additional Assistance</h4><ul><li>Portal <a href='https://drydenmutual.com/faq' target='_blank'>FAQ</a></li><li>Billing Department contacts: <a href='tel:+18006948271'>1-800-694-8271</a> or <a href='mailto:billing@drydenmutual.com'>billing@drydenmutual.com</a></li></ul></p>"
    },
    "notificationSmsNumber": "",
    "billingStatusCd": "Normal, Legal",
    "apiResponseSizeLimit": 100,
    "carrierDomains": {},
    "_meta": {
        "build": "4.0.0-25-25394b3",
        "commit": "25394b34672952cca573143b69a0d78589263139",
        "company": "dmic",
        "date": "2026-04-28T18:36:56+00:00",
        "source": "serviceportal-four-config",
        "version": "4.0.0",
        "imageTag": ""
    }
};